import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import config from '../config';

import { ReactComponent as GeneralIcon } from '../icons/main_menu/general.svg';
import { ReactComponent as ReviewsIcon } from '../icons/main_menu/reviews.svg';
import { ReactComponent as AnalyticsIcon } from '../icons/main_menu/analytics.svg';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import TuneIcon from '@mui/icons-material/Tune';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import CallSplitIcon from '@mui/icons-material/CallSplit';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import SyncIcon from '@mui/icons-material/Sync';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { ReactComponent as SettingsIcon } from '../icons/main_menu/settings.svg';
import React from 'react';
import GeneralSettings from './General';
import GeneralSettingsTabs from './GeneralTabs';
import SplitOTABookingsSettings from './SplitOTABookings';
import SyncBookingsSettings from './SyncBookings';
import SyncOrdersSettings from './SyncOrders';
import CheckinSettings from './checkin/CheckinSettings';
import ReviewList from '../analytics/ReviewList';
import SentimentAnalysisList from '../analytics/SentimentAnalysisList';
import AgentMetricsList from '../analytics/AgentMetricsList';
import NotificationMetricsList from '../analytics/NotificationMetricsList';
import UserRoleManagement from './UserRoles';
import WaiverList from './waivers/WaiverList';
import WaiverEdit from './waivers/WaiverEdit';
import WaiverPreview from './waivers/WaiverPreview';
import LicenseeManagement from './LicenseeManagement';
import TrainingMaterialsTabs from './AITrainingFiles';
import TourChatPriorityPage from './TourChatPriorityPage';
import WebWidgetPage from './WebWidgetPage';
import EmailDomainsPage from './EmailDomainsPage';
import AIEditingSettingsPage from './aiEditing/AIEditingSettingsPage';
import AIVocabularyPage from './aiVocabulary/AIVocabularyPage';

function NotificationMetricsLivePage(props) {
    return (
        <NotificationMetricsList
            forceSource="ch"
            showDebugInfo={false}
            analyticsTabSlug="notification_metrics"
            {...props}
        />
    );
}

function GeneralSettingsPage(props) {
    const useTabbed = config?.features?.tabbedGeneralSettings;
    return useTabbed ? <GeneralSettingsTabs {...props} /> : <GeneralSettings {...props} />;
}

const exports = {
    General: {
        Page: GeneralSettingsPage,
        Icon: GeneralIcon,
    },
    Checkin: {
        Page: CheckinSettings,
        Icon: GeneralIcon,
    },
    Users: {
        Page: UserRoleManagement,
        Icon: AccountCircleIcon,
    },
    Waivers: {
        Page: WaiverList,
        Icon: MenuBookIcon,
        EditPage: WaiverEdit,
        PreviewPage: WaiverPreview,
    },
    Reviews: {
        Page: ReviewList,
        Icon: ReviewsIcon,
    },
    SentimentAnalysis: {
        Page: SentimentAnalysisList,
        Icon: AnalyticsIcon,
    },
    AgentMetrics: {
        Page: AgentMetricsList,
        Icon: AnalyticsIcon,
    },
    NotificationMetrics: {
        Page: NotificationMetricsLivePage,
        Icon: AnalyticsIcon,
    },
    TrainingMaterials: {
        Page: TrainingMaterialsTabs,
        Icon: AutoAwesomeIcon,
    },
    SyncBookings: {
        Page: SyncBookingsSettings,
        Icon: SyncIcon,
    },
    SyncOrders: {
        Page: SyncOrdersSettings,
        Icon: ReceiptLongIcon,
    },
    TourChatPriority: {
        Page: TourChatPriorityPage,
        Icon: LowPriorityIcon,
    },
    WebWidget: {
        Page: WebWidgetPage,
        Icon: SupportAgentIcon,
    },
    SplitOTABookings: {
        Page: SplitOTABookingsSettings,
        Icon: CallSplitIcon,
    },
    Licensees: {
        Page: LicenseeManagement,
        Icon: CorporateFareIcon,
    },
    EmailDomains: {
        Page: EmailDomainsPage,
        Icon: AlternateEmailIcon,
    },
    AIEditing: {
        Page: AIEditingSettingsPage,
        Icon: TuneIcon,
    },
    AIVocabulary: {
        Page: AIVocabularyPage,
        Icon: SpellcheckIcon,
    },
    Icon: SettingsIcon,
};
export default exports;
